// import Button from "../Styledcomponents"
import ContactContainer from "./MainContainer"

import './styles.scss'


function ContactPage(){
    return(
        <div>
            <ContactContainer />
        </div>
    )
}

export default ContactPage
